// extracted by mini-css-extract-plugin
module.exports = {"comment":"ConversationModalRepliesContainer-comment-54fae55436f20d7a83b91276d17ddcdd","footer":"ConversationModalRepliesContainer-footer-5a4be3ada0a843087a8f56606f0043e1"};